import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8'
};

export function Spinner({ size = 'md', color, className }: SpinnerProps) {
  return <Loader2 className={cn('animate-spin', sizeMap[size], color && `text-${color}`, className)} />;
}
